// No Chrome Android, o File vindo de um <input type="file"> (galeria ou câmera) aponta para um
// arquivo do sistema que pode ficar ilegível depois — típico quando o app vai para background
// ao abrir a câmera. A leitura passa a falhar com NotReadableError/ProgressEvent e o IndexedDB
// recusa gravar o blob ("Failed to write blobs (InvalidBlob)"). Copiar o conteúdo para a
// memória enquanto ele ainda é legível desacopla o File do arquivo de origem.
export const readFileIntoMemory = async (file: File): Promise<File> => {
  const buffer = await file.arrayBuffer();
  return new File([buffer], file.name, { type: file.type, lastModified: file.lastModified });
};
